// The colours the statistics dashboard paints its charts with. Every one of them
// was checked against the paper surface of the theme (#36393e): the heat ramp is
// a single hue, monotone in lightness, and its deepest step still clears the
// surface it sits on; the bar and status colours all clear 3:1 against it.
//
// Red and green are the pair a colourblind reader has the most trouble telling
// apart, so no verdict is ever told apart by its colour alone - every row carries
// the name of the verdict, its count and its share next to the bar.

// Solves per cell, running white to red with red for the cells solved the most.
// A cell that was never solved is left as the surface instead of taking the
// first step. The deep end stops short of a dark red so that it still reads
// against the dark surface the board sits on.
const HEAT_STEPS = ['#FDF2F1', '#F7B9B5', '#EC7D78', '#D93B37'];

// The three lightest steps need dark ink on them, the red one needs white
const HEAT_TEXT = ['#1f2226', '#1f2226', '#1f2226', '#ffffff'];

const ACCEPTED_COLOR = '#43AE5A';
const REJECTED_COLOR = '#E2565B';
const CE_COLOR = '#E0A800';
const BAR_COLOR = '#7289DA';
// The second tag chart measures a rate rather than a count, so it is painted
// apart from the others. A yellow this legible cannot sit in the lightness band
// the rest of the palette keeps to - anything darker stops reading as yellow -
// but it clears 3:1 against the surface, and it is the only series in its chart.
const RATE_BAR_COLOR = '#E0A800';

// Which step of the ramp a count belongs in, between the quietest cell of the
// board and the busiest. A board with a cell nobody solved starts the scale at
// zero, so that cell takes the lightest step of the ramp rather than dropping
// out of the scale; -1 is a cell the ramp does not cover at all.
function heatStep(count, max, min = 1) {
    if (max <= 0 || count < min) return -1;
    if (max === min) return HEAT_STEPS.length - 1;
    const step = Math.floor((count - min) / (max - min) * HEAT_STEPS.length);
    return Math.min(step, HEAT_STEPS.length - 1);
}

// The bottom of the scale for a board: zero when some cell has none
const heatFloor = grid => Math.min(...grid, 1);

export { HEAT_STEPS, HEAT_TEXT, ACCEPTED_COLOR, REJECTED_COLOR, CE_COLOR, BAR_COLOR, RATE_BAR_COLOR, heatStep, heatFloor };
